export const STATOPRENOTAZIONE =
{
    DISPONIBILE: 1,
    OCCUPATA: 2,
    DISABILITATA: 3,
    RISERVATA: 4,
    CHECKIN: 5,
}